<template>
  <nav class="flex items-center justify-between border-t border-gray-200 px-4 sm:px-0">
    <div class="-mt-px w-0 flex-1 flex">
      <component
        :is="seo ? 'a' : 'button'"
        v-if="paginator.current_page > 1"
        :href="seo ? getPageUrl(paginator.current_page - 1) : undefined"
        class="inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
        @click="!seo && $emit('page', paginator.current_page - 1)"
      >
        <VIconArrowLeft
          class="mr-3 h-5 w-5 text-gray-400"
          aria-hidden="true"
        />
        {{ trans.get('miliboo.common.previous') }}
      </component>
    </div>
    <div class="hidden md:-mt-px md:flex">
      <template
        v-for="page in visiblePages"
        :key="page"
      >
        <span
          v-if="page === '...'"
          class="inline-flex items-center border-t-2 border-transparent px-4 pt-4 text-sm font-medium text-gray-500"
        >
          {{ page }}
        </span>
        <component
          :is="seo ? 'a' : 'button'"
          v-else
          :href="seo ? getPageUrl(page) : undefined"
          :class="page === paginator.current_page
            ? 'inline-flex items-center border-t-2 border-gray-700 px-4 pt-4 text-sm font-medium text-gray-700'
            : 'inline-flex items-center border-t-2 border-transparent px-4 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700'"
          @click="!seo && $emit('page', page)"
        >
          {{ page }}
        </component>
      </template>
    </div>
    <div class="-mt-px w-0 flex-1 flex justify-end">
      <component
        :is="seo ? 'a' : 'button'"
        v-if="paginator.current_page < paginator.last_page"
        :href="seo ? getPageUrl(paginator.current_page + 1) : undefined"
        class="inline-flex items-center border-t-2 border-transparent pl-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
        @click="!seo && $emit('page', paginator.current_page + 1)"
      >
        {{ trans.get('miliboo.common.next') }}
        <VIconArrowRight
          class="ml-3 size-5 text-gray-400"
          aria-hidden="true"
        />
      </component>
    </div>
  </nav>
</template>

<script setup>
import { computed, inject } from 'vue';
import VIconArrowLeft from '../../icons/VIconArrowLeft.vue';
import VIconArrowRight from '../../icons/VIconArrowRight.vue';

const props = defineProps({
  paginator: {
    type: Object,
    required: true,
  },
  seo: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['page']);

const trans = inject('translate');

const visiblePages = computed(() => {
  const total = props.paginator.last_page;
  const current = props.paginator.current_page;
  const delta = 1;

  if (total <= 7) {
    return Array.from({ length: total }, (_, index) => index + 1);
  }

  const range = (start, end) => Array.from({ length: end - start + 1 }, (_, i) => start + i);

  return [
    1,
    ...(current > delta + 2 ? ['...'] : []),
    ...range(Math.max(2, current - delta), Math.min(total - 1, current + delta)),
    ...(current < total - delta - 1 ? ['...'] : []),
    total,
  ];
});

const getPageUrl = (page) => `${((url) => url.searchParams.set('page', page) || url)(new URL(window.location))}`;
</script>
